import { RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "./RouteProtector";

const ActiveBusinessCount = lazyWithReload(
  () => import("src/chamber/features/activeBusinessCount/ActiveBusinessCount"),
);
const ActiveChamberApplicationsPaid = lazyWithReload(
  () =>
    import(
      "src/chamber/features/activeChamberApplicationsPaid/ActiveChamberApplicationsPaid"
    ),
);

const ActiveChamberApplicationsUnpaid = lazyWithReload(
  () =>
    import(
      "src/chamber/features/activeChamberApplicationsUnpaid/ActiveChamberApplicationsUnpaid"
    ),
);
const ActiveChamberCertificateApplicationsPaid = lazyWithReload(
  () =>
    import(
      "src/chamber/features/activeChamberCertificateApplicationsPaid/ActiveChamberCertificateApplicationsPaid"
    ),
);
const ActiveChamberCertificateApplicationsUnpaid = lazyWithReload(
  () =>
    import(
      "src/chamber/features/activeChamberCertificateApplicationsUnpaid.tsx/ActiveChamberCertificateApplicationsUnpaid"
    ),
);
const ActiveOwnApplications = lazyWithReload(
  () =>
    import("src/chamber/features/activeOwnApplications/ActiveOwnApplications"),
);
const ActiveOwnCertificateApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/activeOwnCertificateApplications/ActiveOwnCertificateApplications"
    ),
);
const ActiveOwnOnlyApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/activeOwnOnlyApplications/ActiveOwnOnlyApplications"
    ),
);
const CashierForecast = lazyWithReload(
  () => import("src/chamber/features/cashierForecast/CashierForecast"),
);
const CashierPaymentDetails = lazyWithReload(
  () =>
    import("src/chamber/features/cashierPaymentDetails/CashierPaymentDetails"),
);
const CashierRemittancesFileDetails = lazyWithReload(
  () =>
    import(
      "src/chamber/features/cashierRemittancesFileDetails/CashierRemittancesFileDetails"
    ),
);
const CashierReport = lazyWithReload(
  () => import("src/chamber/features/cashierReport/CashierReport"),
);
const CashierStats = lazyWithReload(
  () => import("src/chamber/features/cashierStats/CashierStats"),
);
const CompanyReducedSubscription = lazyWithReload(
  () =>
    import(
      "src/chamber/features/companyReducedSubscription/CompanyReducedSubscription"
    ),
);
const CompanySubscription = lazyWithReload(
  () => import("src/chamber/features/companySubscription/CompanySubscription"),
);
const DeleteKak = lazyWithReload(
  () => import("src/chamber/features/deleteKak/DeleteKak"),
);
const InactiveApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/InactiveUserAssignments/ui/InactiveApplications"
    ),
);
const InactiveCertificateApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/InactiveUserAssignments/ui/InactiveCertificateApplications"
    ),
);
const FinancialReport = lazyWithReload(
  () => import("src/chamber/features/financialReport/FinancialReport"),
);
const FindCompanyPayments = lazyWithReload(
  () => import("src/chamber/features/findCompanyPayments/FindCompanyPayments"),
);
const GetAppsByGemi = lazyWithReload(
  () => import("src/chamber/features/getAppsByGemi/GetAppsByGemi"),
);
const GetCertsByGemi = lazyWithReload(
  () => import("src/chamber/features/getCertsByGemi/GetCertsByGemi"),
);
const KedeSubscriptions = lazyWithReload(
  () => import("src/chamber/features/kedeSubscriptions/KedeSubscriptions"),
);
const ManageApplication = lazyWithReload(
  () => import("src/chamber/features/manageApplication/ManageApplication"),
);
const ChamberManageCertificateApplication = lazyWithReload(
  () =>
    import(
      "src/chamber/features/manageCertificateApplication/ManageCertificateApplication"
    ),
);
const ManageSubscription = lazyWithReload(
  () => import("src/chamber/features/manageSubscription/ManageSubscription"),
);
const NewApplication = lazyWithReload(
  () => import("src/chamber/features/newApplication/NewChamberApplication"),
);
const PastOwnApplications = lazyWithReload(
  () => import("src/chamber/features/pastOwnApplications/PastOwnApplications"),
);
const PastOwnCertificateApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/pastOwnCertificateApplications/PastOwnCertificateApplications"
    ),
);
const UnpaidSubscriptions = lazyWithReload(
  () => import("src/chamber/features/unpaidSubscriptions/UnpaidSubscriptions"),
);
const UserDetails = lazyWithReload(
  () => import("src/chamber/features/userDetails/UserDetails"),
);

const CashierRemittances = lazyWithReload(
  () => import("src/chamber/features/cashierRemittances/CashierRemittances"),
);

const ImpersonationPageBusiness = lazyWithReload(
  () =>
    import(
      "src/chamber/features/ImpersonationPageBusiness/ImpersonationPageBusiness"
    ),
);
const UnsignedOwnCertificateApplications = lazyWithReload(
  () =>
    import(
      "src/chamber/features/unsignedOwnCertificateApplications/UnsignedOwnCertificateApplications"
    ),
);

import ActiveAadeCase from "src/aadeCase/features/ActiveAadeCase";
import ManageAadeCaseApplication from "src/aadeCase/features/ManageAadeCaseApplication";
import UnregisteredAadeCases from "src/aadeCase/features/UnregisteredAadeCases";
import PastAadeCases from "src/aadeCase/features/PastAadeCases";
import NewDashboard from "src/chamber/features/dashboard/NewDashboard";

export const chamberRoutes: RouteObject = {
  path: "/chamber",
  children: [
    {
      path: "dashboard",
      element: (
        <RouteProtector
          allowedUsers={[
            "isChamber",
            "isSupervisorAssignee",
            "isSupervisorAssigner",
          ]}
        >
          <NewDashboard />
        </RouteProtector>
      ),
    },
    {
      path: "activeOwnOnlyApplications",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ActiveOwnOnlyApplications />
        </RouteProtector>
      ),
    },
    {
      path: "activeChamberApplicationsPaid",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ActiveChamberApplicationsPaid />
        </RouteProtector>
      ),
    },
    {
      path: "manageApplication",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ManageApplication />
        </RouteProtector>
      ),
    },
    {
      path: "getAppsByGemi",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <GetAppsByGemi />
        </RouteProtector>
      ),
    },
    {
      path: "activeChamberApplicationsUnpaid",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ActiveChamberApplicationsUnpaid />
        </RouteProtector>
      ),
    },
    {
      path: "activeOwnApplications",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ActiveOwnApplications />
        </RouteProtector>
      ),
    },
    {
      path: "pastOwnApplications",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <PastOwnApplications />
        </RouteProtector>
      ),
    },
    {
      path: "activeOwnCertificateApplications",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ActiveOwnCertificateApplications />
        </RouteProtector>
      ),
    },
    {
      path: "activeChamberCertificateApplicationsPaid",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ActiveChamberCertificateApplicationsPaid />
        </RouteProtector>
      ),
    },
    {
      path: "activeChamberCertificateApplicationsUnpaid",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ActiveChamberCertificateApplicationsUnpaid />
        </RouteProtector>
      ),
    },
    {
      path: "getCertsByGemi",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <GetCertsByGemi />
        </RouteProtector>
      ),
    },
    {
      path: "pastOwnCertificateApplications",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <PastOwnCertificateApplications />
        </RouteProtector>
      ),
    },
    {
      path: "manageCertificateApplication",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ChamberManageCertificateApplication />
        </RouteProtector>
      ),
    },
    {
      path: "newApplication",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <NewApplication />
        </RouteProtector>
      ),
    },
    {
      path: "userDetails",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <UserDetails />
        </RouteProtector>
      ),
    },
    {
      path: "cashierForecast",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CashierForecast />
        </RouteProtector>
      ),
    },
    {
      path: "companySubscription",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CompanySubscription />
        </RouteProtector>
      ),
    },
    {
      path: "cashierPaymentDetails/:paymentType/:date",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CashierPaymentDetails />
        </RouteProtector>
      ),
    },
    {
      path: "inactiveApplications",
      element: (
        <RouteProtector allowedUsers={["isOrgAdmin"]}>
          <InactiveApplications />
        </RouteProtector>
      ),
    },
    {
      path: "inactiveCertificateApplications",
      element: (
        <RouteProtector allowedUsers={["isOrgAdmin"]}>
          <InactiveCertificateApplications />
        </RouteProtector>
      ),
    },
    {
      path: "deleteKak",
      element: (
        <RouteProtector allowedUsers={["isOrgAdmin"]}>
          <DeleteKak />
        </RouteProtector>
      ),
    },
    {
      path: "cashierRemittances",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CashierRemittances />
        </RouteProtector>
      ),
    },
    {
      path: "activeBusinessCount",
      element: (
        <RouteProtector allowedUsers={["isOrgAdmin"]}>
          <ActiveBusinessCount />
        </RouteProtector>
      ),
    },
    {
      path: "remittancesFileDetails/:p04Id",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CashierRemittancesFileDetails />
        </RouteProtector>
      ),
    },
    {
      path: "findCompanyPayments",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <FindCompanyPayments />
        </RouteProtector>
      ),
    },
    {
      path: "companyReducedSubscription",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CompanyReducedSubscription />
        </RouteProtector>
      ),
    },
    {
      path: "financialReport",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <FinancialReport />
        </RouteProtector>
      ),
    },
    {
      path: "cashierReport",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CashierReport />
        </RouteProtector>
      ),
    },
    {
      path: "unpaidSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <UnpaidSubscriptions />
        </RouteProtector>
      ),
    },
    {
      path: "kedeSubscriptions",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <KedeSubscriptions />
        </RouteProtector>
      ),
    },
    {
      path: "cashierStats",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <CashierStats />
        </RouteProtector>
      ),
    },
    {
      path: "manageSubscription/:subId",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ManageSubscription />
        </RouteProtector>
      ),
    },
    ...(import.meta.env.VITE_ClEANSING_ACTIVATED === "true"
      ? [
          {
            path: "activeAadeCases",
            element: (
              <RouteProtector allowedUsers={["isChamber"]}>
                <ActiveAadeCase />
              </RouteProtector>
            ),
          },
          {
            path: "unRegisteredAadeCases",
            element: (
              <RouteProtector allowedUsers={["isOrgAdmin"]}>
                <UnregisteredAadeCases />
              </RouteProtector>
            ),
          },
          {
            path: "pastAadeCases",
            element: (
              <RouteProtector allowedUsers={["isChamber"]}>
                <PastAadeCases />
              </RouteProtector>
            ),
          },
          {
            path: "manageAadeCaseApplication/:caseId",
            element: (
              <RouteProtector allowedUsers={["isChamber"]}>
                <ManageAadeCaseApplication />
              </RouteProtector>
            ),
          },
        ]
      : []),
    {
      path: "impersonationPageBusiness",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <ImpersonationPageBusiness />
        </RouteProtector>
      ),
    },
    {
      path: "unsignedOwnCertificateApplications",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <UnsignedOwnCertificateApplications />
        </RouteProtector>
      ),
    },
  ],
};
